import { Provider } from '@angular/core';

import { IrpfReadjustmentRepositoryImpl } from '@app/data/repositories/ptrab/irpf-readjustment/irpf-readjustment.repository';
import { IRPF_READJUSTMENT_REPOSITORY } from '@app/domain/repositories/ptrab/irpf-readjustment/irpf-readjustment.repository.contract';

export const irpfReadjustmentRepositoryProvider: Provider = {
  provide: IRPF_READJUSTMENT_REPOSITORY,
  useClass: IrpfReadjustmentRepositoryImpl
};
